<template>
  <div class="manual-text">
    <div>
      <h1 class="text-center mt-2 mb-10">Various</h1>

      <!-- Default KPIs and PSIs lists -->
      <h2>a. Default KPIs and PSIs list</h2>

      <p>
        The USE web application comes with a default list of KPIs and PSIs along their functional units. These indicators
        can be used in the forms in order to be added in user projects and provide further project-specific details.
        The KPIs list can be access by clicking on the link "KPIs List" in the left side menu, while the PSIs list can be
        accessed by clicking the "PSIs List" link in the same menu.
      </p>

      <div class="image-container">
        <img src="@/images/manual/kpis-psis-list-buttons.png" alt="the kpis psis list buttons" />
        <div class="img-caption">
          Figure 1. The KPI/PSI list buttons' location.
        </div>
      </div>

      <p>
        After clicking one of the two links, the user will be redirected to a new page where a table of all the default
        indicators are included. The list is searchable and the user can search any indicator by its name or its functional
        unit.
      </p>

      <div class="image-container">
        <img src="@/images/manual/kpis-psis-list.png" alt="the kpis psis list" />
        <div class="img-caption">
          Figure 2. The KPIs/PSIs list.
        </div>
      </div>

      <!-- Upload custom KPIs and PSIs -->

      <h2>
        b. Upload Custom KPIs and PSIs
      </h2>

      <p>
        The list of default KPIs or PSIs can be further extended by custom indicators defined by the user. This action
        can be performed only after the user has successfully logged in in their account. The custom indicators are inserted
        indirectly when the user uploads a project in USE by using the file upload feature which will be described later
        in this section. Upon uploading a project through file upload, USE parses the list of KPIs or PSIs and if any
        unknown indicators are identified they are automatically added in the corresponding default list. The new indicators
        can then be used in the KPI or PSI forms in new projects.
      </p>

      <h2>c. Upload a project with file</h2>

      <p>
        As mentioned in the previous paragraph, the users can prepare a file which contains a project definition and then
        upload it to USE so that the data can be loaded dynamically without going through the KPI / PSI form process.
        The file to be uploaded must follow the template provided by USE. The user should download this template, provided
        by USE during the file upload process, prepare the data and then save the file as CSV (.csv) using as a delimiter
        the semicolon (;) character before uploading it to USE. It is important that the file prepared by the user, before
        the conversion to CSV, to NOT include any semicolon characters and the dot (.) character is used to indicate the
        decimal points in numbers.
      </p>

      <p>
        In order to upload a project using file upload, click the corresponding button, with the
        <i class="fas fa-plus-circle" /> <b>plus sign</b> in the <b>middle-left side</b> of the <b>navigation bar</b>
        (Upload Custom KPI, Upload Custom PSI).
        Once pressed, a small modal will appear prompting the user to upload a file and name the KPI/PSI list. On the top
        of the modal there is a button to download the template mentioned previously. Following, there are two inputs,
        the first one being a file input where the user can upload the file they have prepared and below a "list name"
        input. The latter input is used as an identifier so that the user can reference the uploaded project later. After
        both inputs have been provided the user can submit the form and if the file is correct the KPI or PSI list will
        be stored in USE. While uploading the file the default KPIs or PSIs lists (depending on the action) will be extended
        as explained previously.
      </p>

      <div class="image-container">
        <img src="@/images/manual/upload-custom-psi-kpi-button-and-modal.png" alt="the kpis psis list" />
        <div class="img-caption">
          Figure 3. Uploading a custom KPI/PSI.
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>
  p {
    margin-top: 0.75rem;
  }
</style>
